module.exports = __webpack_public_path__ + "img/logo.15327674.png";